import type { ReactNode } from "react";

/**
 * Top metadata card for detail pages (care plan, case). A header row with a
 * title and an optional `actions` slot, above a responsive grid of `Field`s.
 */
function Root({ title, actions, children }: { title: ReactNode; actions?: ReactNode; children: ReactNode }) {
  return (
    <div className="rounded-lg border bg-card">
      <div className="flex items-center justify-between px-5 pt-4 pb-3">
        <h2 className="text-sm font-semibold">{title}</h2>
        {actions}
      </div>
      <div className="grid grid-cols-2 gap-x-6 gap-y-4 px-5 pb-5 sm:grid-cols-4">{children}</div>
    </div>
  );
}

/** A labeled metadata field in the card grid. */
function Field({ label, children }: { label: string; children: ReactNode }) {
  return (
    <div className="flex flex-col gap-1.5">
      <div className="text-xs text-muted-foreground">{label}</div>
      <div className="text-sm">{children}</div>
    </div>
  );
}

export const DetailCard = Object.assign(Root, { Field });
